import questionService from '@/services/question.js';

export default {
	debug: false,
	namespaced: true,
	state: {
		questions: [],
		question: {},
		searchParams: {
			questionGroupId: '',
			description: '',
			Positive: '',
			Negative: '',
			orderBy: 'Created',
			pageSize: 10,
			currentPage: 1
		},
		totalCount: 0,
		totalPages: 0
	},

	mutations: {
		SET_QUESTIONS(state, questions) {
			state.questions = questions;
		},
		SET_QUESTION(state, question) {
			state.question = question;
		},
		SET_PAGESIZE(state, pageSize) {
			state.searchParams.pageSize = pageSize;
		},
		SET_CURRENTPAGE(state, currentPage) {
			state.searchParams.currentPage = currentPage;
		},
		SET_TOTALPAGES(state, totalPages) {
			state.totalPages = totalPages;
		},
		SET_TOTALCOUNT(state, totalCount) {
			state.totalCount = totalCount;
		}
	},

	actions: {
		async getQuestion({ commit }, questionId) {
			return await questionService
				.getQuestion(questionId)
				.then(data => {
					commit('SET_QUESTION', data);
				})
				.catch(err => {
					console.log('Error getting question: ', err);
				});
		},
		async getQuestions({ state, commit, dispatch }) {
			dispatch('appStore/setLoading', 1, { root: true });

			return await questionService
				.getQuestions(state.searchParams)
				.then(data => {
					const paginationValues = data._pagination;

					if (state.searchParams.currentPage <= paginationValues.totalPages || paginationValues.totalPages == 0) {
						commit('SET_QUESTIONS', data);
						commit('SET_CURRENTPAGE', paginationValues.currentPage);
						commit('SET_TOTALCOUNT', paginationValues.totalCount);
						commit('SET_TOTALPAGES', paginationValues.totalPages);
						dispatch('appStore/setLoading', -1, { root: true });
					} else {
						commit('SET_CURRENTPAGE', paginationValues.totalPages);
						dispatch('getQuestions');
						dispatch('appStore/setLoading', -1, { root: true });
					}
				})
				.catch(err => {
					console.log('Error getting questions: ', err);
				});
		},
		async createQuestion({ dispatch }, question) {
			return await questionService
				.createQuestion(question)
				.then(() => {
					dispatch('getQuestions');
				})
				.catch(err => {
					console.log('Error creating question: ', err);
				});
		},
		async updateQuestion({ dispatch }, question) {
			return await questionService
				.updateQuestion(question)
				.then(() => {
					dispatch('getQuestions');
				})
				.catch(err => {
					console.log('Error updating question: ', err);
				});
		},
		async deleteQuestion({ dispatch }, question) {
			return await questionService
				.deleteQuestion(question.id)
				.then(() => {
					dispatch('getQuestions');
				})
				.catch(err => {
					console.log('Error deleting question: ', err);
				});
		},

		setQuestion({ commit }, question) {
			commit('SET_QUESTION', question);
		},
		setQuestions({ commit }, question) {
			commit('SET_QUESTIONS', question);
		},
		setCurrentPage({ commit }, currentPage) {
			commit('SET_CURRENTPAGE', currentPage);
		},
		setPageSize({ commit }, pageSize) {
			commit('SET_PAGESIZE', pageSize);
		},
		setTotalPages({ commit }, totalPages) {
			commit('SET_TOTALPAGES', totalPages);
		},
		setTotalCount({ commit }, totalCount) {
			commit('SET_TOTALCOUNT', totalCount);
		}
	},

	getters: {
		totalPages: state => {
			return state.totalPages;
		},
		totalCount: state => {
			return state.totalCount;
		},
		currentPage: state => {
			return state.searchParams.currentPage;
		},
		pageSize: state => {
			return state.searchParams.pageSize;
		},
		questions: state => {
			return state.questions;
		},
		question: state => {
			return state.question;
		},
		pagination: state => {
			return {
				currentPage: state.searchParams.currentPage,
				pageSize: state.searchParams.pageSize,
				totalPages: state.totalPages,
				totalCount: state.totalCount
			};
		}
	}
};
